import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: true,
  selector: 'mode-legacy-dialog-footer',
  imports: [CommonModule],
  templateUrl: './legacy-dialog-footer.component.html',
  styleUrls: ['./legacy-dialog-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LegacyDialogFooterComponent {
  @Output() closed = new EventEmitter<void>();
}
